import React, { useEffect, useContext } from "react";
import { SecurityContext } from "context/SecurityContextProvider";
import { MisDocumentosContext } from "context/v3/MisDocumentosContext";
import { ItemDocumento } from "./ItemDocumento";
import { LoadingDocumentos } from "components/LoadingDocumentos";
import { Alert } from "antd";
import * as atomsConsulta from "../../../../../hooks/consultas/ConsultasStorage";
import { useAtom } from "jotai";
import { PortalColaboradorService } from "services/PortalColaboradorService";
import { EstadoVistaColaborador } from "enum/EstadoVistaColaborador";
import { agruparPorOnboarding, aplicaAgrupacionOnboarding } from "pages/v3/mis-pendientes/common/utils/agruparPorOnboarding";
import {
	visibleModalConsentimientoDatosAtom,
	documentoConsentimientoAtom,
} from "../MisDocumentosMovilStorage";

const NOMBRE_DOCUMENTO_CONSENTIMIENTO = "CONSENTIMIENTO PARA USO DE DATOS PERSONALES-IMAGEN";

const ListaDocumentos = () => {
	const { loading, documentos, getDocumentos } = useContext(MisDocumentosContext);

	const { getUsuarioAutenticado } = useContext(SecurityContext);
	const [totalRespuestasUsuario, setTotalRespuestasUsuario] = useAtom(atomsConsulta.totalRespuestasUsuarioAtom);
	const [, setDocumentoConsentimiento] = useAtom(documentoConsentimientoAtom);
	const [, setVisibleModalConsentimiento] = useAtom(visibleModalConsentimientoDatosAtom);

	useEffect(() => {
		getDocumentos(getUsuarioAutenticado().empresaSeleccionada.id, getUsuarioAutenticado().numeroDocumentoIdentidad);
		obtenerNumeroDetalleNoVisualizadas();
	}, []);

	useEffect(() => {
		const esExplomin = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20501523837";
		if (esExplomin && !loading && documentos && documentos.length > 0) {
			const docConsentimiento = documentos.find(
				(doc) =>
					doc.nombreDocumento &&
					doc.nombreDocumento.toUpperCase().includes(NOMBRE_DOCUMENTO_CONSENTIMIENTO) &&
					doc.estadoVistaColaborador === EstadoVistaColaborador.PENDIENTE
			);
			if (docConsentimiento) {
				setDocumentoConsentimiento(docConsentimiento);
				setVisibleModalConsentimiento(true);
			}
		}
	}, [documentos, loading]);

	const obtenerNumeroDetalleNoVisualizadas = async () => {
		const consultas = await PortalColaboradorService.listaConsultas(
			getUsuarioAutenticado().empresaSeleccionada.id,
			getUsuarioAutenticado().numeroDocumentoIdentidad
		);
		let listaConsultasId = [];
		if (consultas.length > 0) {
			consultas.map((consulta) => {
				listaConsultasId.push(consulta.id);
			});
			const respuestasXConsulta = await PortalColaboradorService.listaNumeroRespuestas(
				listaConsultasId,
				"respuestaUsuario"
			);
			let totalRespuestas = 0;
			respuestasXConsulta.length > 0 &&
				respuestasXConsulta.map((respuesta) => {
					respuesta.numeroRespuestas > 0 && totalRespuestas++;
				});
			setTotalRespuestasUsuario(totalRespuestas);
		}
	};
	const Documentos = () => {
		if (aplicaAgrupacionOnboarding(getUsuarioAutenticado()) && documentos.some((d) => d.onboardingNombre)) {
			return agruparPorOnboarding(documentos).map((grupo) => (
				<React.Fragment key={grupo.id}>
					{grupo.nombre && (
						<div style={{ fontWeight: 600, padding: "12px 4px 4px" }}>
							{grupo.nombre} ({grupo.documentos.length})
						</div>
					)}
					{grupo.documentos.map((documento, index) => (
						<ItemDocumento key={`${grupo.id}-${index}`} documento={documento} numero={index + 1} />
					))}
				</React.Fragment>
			));
		}
		const items = documentos.map((documento, index) => <ItemDocumento key={index} documento={documento} />);
		return items;
	};

	return (
		<div className="bandeja-entrada__container-documentos">
			{totalRespuestasUsuario > 0 && (
				<Alert
					message="Estimado Colaborador, tiene notificaciones pendientes de revisar."
					type="info"
					showIcon
				/>
			)}
			{loading && <LoadingDocumentos items={5} />}
			{!loading && <Documentos />}
		</div>
	);
};

export default ListaDocumentos;
